import transferVoiceCall from './transferVoiceCall';

export default transferVoiceCall;
